import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { isTokenExpired } from '../../../services/authentication/utils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LoginFormComponent from '../../authentication/login/LoginFormComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './LoginPage.scss';

export class LoginPage extends React.Component {
    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }

    isMemberAuthenticated = () => !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history }) {
        if (this.isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                history.push(PATH.HOME_PATH);
                resolve();
            });
        }
    }

    render() {
        const { i18nPage, i18nForm } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-login">
                <HeadComponent
                    title={i18nPage.TITLE}
                    description={i18nPage.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.LOGIN_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.LOGIN_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18nPage.TITLE}</h1>

                <LoginFormComponent />
                <p className="register-link txtcenter">
                    {i18nForm.NOT_REGISTERED}
                    <LocalizedNavLink to={PATH.REGISTER_PATH}>{i18nPage.REGISTER}</LocalizedNavLink>
                </p>
            </main>
        );
    }
}

LoginPage.propTypes = {
    i18nPage: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.LOGIN,
        i18nForm: state.i18n.feature.form,
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated
    };
};

export default withTemplate(connect(mapStateToProps, null)(LoginPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/login/LoginPage.js